module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07463_banner_800x600.17275ab2.png";